module.exports = __webpack_public_path__ + "media/images/gallery_4-8236e972.jpg";